<template>
  <div class="wrapper fadeInDown">
    <!-- BOTÓN REGRESAR -->
    <button class="btn btn-outline-light mb-3 back-btn" @click="$router.push('/')">
      <i class="bi bi-arrow-left-circle"></i> Regresar al Login
    </button>

    <!-- ENVÍO DE CORREO / PIN -->
    <div id="formContent" v-if="correo">
      <h3 class="text-center title-card mb-4">
        RECUPERACION DE CONTRASEÑA
      </h3>

      <div v-if="pin">
        <label class="labeltamaño">CORREO CORPORATIVO
        </label>

        <div class="input-group">
          <input
            type="email"
            class="form-control custom-input"
            placeholder="usuario@gruposolimano.com.pe"
            v-model="correoenviar"
          />
          <button class="btn btn-primary" @click="mandarCorreo">
            <i class="bi bi-envelope-fill"></i>
          </button>
        </div>
      </div>

      <div v-else>
        <h5 class="text-center text-danger mb-3">
          Tiempo de expiración: {{ tiempo }} 
        </h5>

        <label class="labeltamaño">Ingrese PIN</label>
        <input
          type="text"
          class="form-control custom-input"
          placeholder="Código PIN"
          v-model="enviarPin"
        />

        <div class="text-center mt-3">
          <button class="btn btn-success px-4" @click="mandarPin">
            <i class="bi bi-check-circle"></i> Verificar
          </button>
        </div>
      </div>
    </div>

    <!-- CAMBIO DE CONTRASEÑA -->
    <div v-if="recuperarContra" id="formContent">
      <h5 class="text-center text-danger mb-2">
        Tiempo de expiración: {{ tiempo }} s
      </h5>

      <h3 class="text-center title-card mb-4">
        Cambiar Contraseña
      </h3>

      <form @submit.prevent="login">
        <label class="labeltamaño">Documento de Identidad</label>
        <input
          type="text"
          disabled
          class="form-control custom-input"
          placeholder="Ingrese DNI"
          v-model="user.usuCodigo"
        />

        <label class="labeltamaño mt-3">Nueva Contraseña</label>

        <div class="input-group">
          <input
            ref="passwordInput"
            :type="ojoAbierto ? 'password' : 'text'"
            class="form-control custom-input"
            placeholder="********"
            maxlength="8"
            v-model="user.usuContrasena"
            @input="validatePassword"
          />
          <button class="btn btn-outline-secondary" @click.prevent="togglePasswordVisibility">
            <i :class="ojoAbierto ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
          </button>
        </div>

        <small class="text-muted d-block mt-2 text-center">
          Mínimo 8 caracteres. Usa letras y números.
        </small>

        <div class="text-center mt-4">
          <button v-if="boton" class="btn btn-primary px-5">
            Cambiar Contraseña
          </button>
        </div>

        <div class="alert alert-danger mt-3" v-if="error">
          {{ error_msg }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "SolimanologConstraseANueva",

  data() {
    return {
      user: {
        usuCodigo: "",
        usuContrasena: "",
      },
      correoenviar: "",
      error: false,
      boton: true,
      correo: true,
      pin: true,
      enviarPin: "",
      recuperarContra: false,
      tiempo: "",
      ojoAbierto: true,
    };
  },

  methods: {
    togglePasswordVisibility() {
      this.ojoAbierto = !this.ojoAbierto;
    },

    validatePassword() {
      const regex = /^[A-Za-z0-9]+$/;
      if (!regex.test(this.user.usuContrasena)) {
        this.user.usuContrasena = this.user.usuContrasena.replace(
          /[^A-Za-z0-9]/g,
          ""
        );
      }
    },

    iniciarContador() {
      setInterval(() => {
        if (this.tiempo > 0) {
          this.tiempo--;
        } else {
          location.reload();
        }
      }, 1000);
    },

    mandarCorreo() {
      this.axios
        .post(`Values/CorreoValidacion?correoUsuario=${this.correoenviar}`)
        .then((r) => {
          this.tiempo = r.data.tiempoExpiracion * 60;
          if (r.data.result) {
            Swal.fire("Éxito", "Código enviado al correo", "success");
            this.correoenviar = "";
            this.pin = false;
            this.iniciarContador();
          } else {
            Swal.fire("Error", "Correo incorrecto", "error");
          }
        });
    },

    mandarPin() {
      this.axios
        .get(`Values/VerificarToken?token=${this.enviarPin}`)
        .then((r) => {
          console.log(r.data);
          if(r.data.success){
          this.user.usuCodigo = r.data.usuCodigo;
          this.recuperarContra = true;
          this.correo = false;
          }
         
        });
    },

    login() {
      this.axios
        .post(
          `Values/RestablecerContrasena?dni=${this.user.usuCodigo}&nuevaContrasena=${this.user.usuContrasena}`
        )
        .then((r) => {
          if (r.data) {
            Swal.fire("Éxito", "Contraseña actualizada", "success");
            this.$router.push("/");
          } else {
            Swal.fire("Error", "DNI incorrecto", "error");
          }
        });
    },
  },
};
</script>

<style scoped>
.wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #003973, #e5e5be);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
}

#formContent {
  background: #ffffff;
  border-radius: 15px;
  padding: 35px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
}

.title-card {
  font-weight: 700;
  color: #003973;
}

.labeltamaño {
  font-weight: 600;
  color: #005fa3;
  margin-bottom: 6px;
}

.custom-input {
  border-radius: 10px;
  padding: 12px;
}

.back-btn {
  align-self: flex-start;
}

button i {
  margin-right: 5px;
}
</style>
